import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Button, XMarkdown} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', (
            _$cc(Button, {
                'type': 'primary',
                'ev-click': this.restart,
                'children': '重新渲染'
            })
        ), 2, 'xmarkdown-demo-citations-actions'),
        _$cc(XMarkdown, {
            'content': this.get('content'),
            'typing': this.get('typing'),
            'streaming': this.get('streaming'),
            'plugins': [this.getCitationPlugin()]
        })
    ], 4, 'xmarkdown-demo-citations');
};